import { Controller } from "@hotwired/stimulus"

// Floating chrome earns its edge only once there is something underneath it.
//
// A permanent 1px rule under a sticky header draws a line where the page has
// not been divided yet. This waits until content has actually scrolled beneath
// the bar, and then fades a soft edge in instead of snapping a border on.
export default class extends Controller {
  static values = { at: { type: Number, default: 4 } }

  connect() {
    this.ticking = false
    this.onScroll = this.schedule.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  schedule() {
    if (this.ticking) return

    this.ticking = true
    requestAnimationFrame(() => {
      this.update()
      this.ticking = false
    })
  }

  update() {
    this.element.classList.toggle("is-scrolled", window.scrollY > this.atValue)
  }
}
